import { baseApi } from "api/BaseApi";

import { Feature, FeaturePayload } from "./features.types";

const FEATURES_BASE_URL = "/features/features";

export const featuresApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getFeatures: build.query<Feature[], FeaturePayload>({
      query: (params) => ({
        url: `${FEATURES_BASE_URL}/`,
        params,
      }),
      providesTags: ["FEATURES"],
    }),
  }),

  overrideExisting: false,
});

export const { useGetFeaturesQuery, useLazyGetFeaturesQuery } = featuresApi;
